/**
 * Get the size of item in the square grid container from it's width.
 * @param {number} columnCount
 * @param {number} columnGap
 * @param {number} containerWidth
 * @returns {number}
 */
const getItemSize = (columnCount, columnGap, containerWidth) => {
  return (containerWidth - (columnCount - 1) * columnGap) / columnCount;
};

export default getItemSize;
